module.exports = __webpack_public_path__ + "img/verification.eb7c099c.svg";